import { convertCaseToFilterFormat } from 'utils/utils';
import { totalCountEvent } from 'services/generalServices';
import { listGlobalTags } from 'services/Settings';
import { courtDateEvent, summarizeDocument } from 'services/fileManager/fileManagerServices';

export const createOnResetFilter = (deps) => {
  const {
    setFileManagerFilters,
    setQuery,
    setBreadCrumbs,
    userContext,
    isCaseFileManager,
    isClientFileManager,
    isLeadFileManager,
    isFirmDocuments,
  } = deps;

  let filter = {
    fileType: '',
    tag: '',
    case: isClientFileManager ? convertCaseToFilterFormat(userContext?.clientSelectedCase) : '',
    selectedFolder: '',
    ...(userContext?.access_level === 'client' && { shared_folder: true }),
  };

  return function onResetFilter() {
    if (isCaseFileManager || isClientFileManager || isLeadFileManager) {
      setFileManagerFilters((prev) => ({
        ...filter,
        fileStatus: '',
        // preserve current folder if it exists
        selectedFolder: prev?.selectedFolder || '',
        folder_id: prev?.folder_id || '',
        folder_type: prev?.folder_type || '',
        is_virtual: prev?.is_virtual || '',
        is_system_folder: prev?.is_system_folder || '',
      }));
    } else {
      setFileManagerFilters((prev) => ({
        ...filter,
        is_read: '',
        start_date: '',
        end_date: '',
        uploadedBy: isFirmDocuments ? 'client' : '',
        is_client_uploaded: isFirmDocuments ? false : '',
        esignature_status: '',
        forceCaseUndefined: false,
        isFirmUploads: false,
        // preserve current folder if it exists
        selectedFolder: prev?.selectedFolder || '',
        folder_id: prev?.folder_id || '',
        folder_type: prev?.folder_type || '',
        is_virtual: prev?.is_virtual || '',
        is_system_folder: prev?.is_system_folder || '',
      }));
    }
    setQuery('');
    // setBreadCrumbs([]);
  };
};

export const createGetGlobalTags = ({ setGlobalTags }) => {
  return async function getGlobalTags() {
    try {
      const response = await totalCountEvent('global_tag');
      const res = await listGlobalTags(response.data);

      const tagsArray = (res?.data?.global_tag || []).map((item) => ({
        name: item.tag,
        value: item.tag,
      }));

      setGlobalTags(tagsArray);
    } catch (error) {
      console.error('Error fetching global tags:', error);
    }
  };
};

export const createHandleSummarizeFile = ({ setSelectedItem, setSummaryGenerationStatus }) => {
  return async function handleSummarizeFile(rowData, data) {
    setSelectedItem(rowData);

    if (!data || Object.keys(data).length === 0) return;

    const statusKey = rowData?.file_id || rowData?.object_id || rowData?.sk?.split('#')?.[1];

    try {
      const res = await summarizeDocument(data);

      if (statusKey && res?.data === 'Summary is being generated') {
        setSummaryGenerationStatus((prev) => ({
          ...prev,
          [statusKey]: {
            summary_generation_status: 'in_progress',
            summary_status: 'processing',
            file_id: statusKey,
            version_id: rowData.version_id,
            file_path: rowData.file_path,
          },
        }));
      }
    } catch (error) {
      console.error(error);

      if (statusKey) {
        setSummaryGenerationStatus((prev) => ({
          ...prev,
          [statusKey]: {
            ...prev[statusKey],
            summary_generation_status: 'failed',
            summary_status: 'failed',
            error_status: true,
          },
        }));
      }
    }
  };
};

export const createHandleShowSummaryModal = (deps) => {
  const { setSelectedItem, setSummaryData, setSummaryVersions, setShowSummarizeModal, websocketContext } = deps;

  const summaryExistsInArray = (summary, array) => {
    if (!summary || !array) return false;

    const isSameSummary = (a, b) =>
      (a?.version_id && b?.version_id && a.version_id === b.version_id) || (a?.s3_path && b?.s3_path && a.s3_path === b.s3_path);

    return array.some((existing) => isSameSummary(summary, existing));
  };

  return function handleShowSummaryModal(rowData) {
    setSelectedItem(rowData);

    const wsData = websocketContext?.aiFileSummary;
    const existingVersions = rowData?.summary_versions || [];

    let mergedVersions = [...existingVersions];

    if (wsData && rowData?.file_id) {
      const wsSummary = wsData?.body?.summary;
      const wsVersions = wsData?.body?.summary_versions || [];
      const latestWsVersion = wsVersions[wsVersions.length - 1];

      const matchesFile = wsSummary?.file_id === rowData.file_id || latestWsVersion?.parameters?.file_path === rowData.file_path;

      if (matchesFile) {
        // Replace or merge versions intelligently
        if (wsVersions.length > 0) {
          mergedVersions = wsVersions;
        } else if (latestWsVersion && !summaryExistsInArray(latestWsVersion, mergedVersions)) {
          mergedVersions = [...mergedVersions, latestWsVersion];
        }
      }
    }

    if (!mergedVersions.length) return;

    const successfulSummaries = mergedVersions.filter((s) => s?.s3_path && s?.error_status === false);

    if (!successfulSummaries.length) return;

    const currentSummary = successfulSummaries[successfulSummaries.length - 1];

    setSummaryData(currentSummary);
    setSummaryVersions(successfulSummaries.slice(0, -1));
    setShowSummarizeModal(true);
  };
};

export const createHandleShowCreateEvent = (deps) => {
  const { setShowCreateEventModal, setSelectedItem, setCourtDateMsg } = deps;
  return function handleShowCreateEvent(rowData, data) {
    setShowCreateEventModal(true);
    setSelectedItem(rowData);

    if (data && Object.keys(data).length > 0) {
      courtDateEvent(data)
        .then((res) => setCourtDateMsg(res?.data))
        .catch(console.error);
    }
  };
};
